import { useState } from "react";
import axios from "axios";

export default function ForgotPassword() {
const API = process.env.REACT_APP_BACKEND_URL;
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await axios.post(`${API}/forgot-password`, { email });
    setMessage(res.data.message);
  };

  return (
    <form onSubmit={handleSubmit}>
        <h2>Jelszó visszaállítása</h2>
      <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" />
      <button type="submit">Email küldése</button>
      <p>{message}</p>
    </form>
  );
}